<template>
    <div class="usersAdd">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
            <el-breadcrumb-item>添加用户</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :model="addUserForm" ref="addUserForm" :rules="validateRules" label-width="100px" class="addUserForm">
            <el-form-item label="邮箱" prop="accountEmail">
                <el-input v-model="addUserForm.accountEmail"  placeholder="请填写一点资讯邮箱，如：xxx@yidian-inc.com"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="addUserForm.password" auto-complete="off"  placeholder="请填写长度不少于6位的密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
                <el-input type="password" v-model="addUserForm.confirmPassword" auto-complete="off" placeholder="请再次填写密码"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="userName">
                <el-input v-model="addUserForm.userName"  placeholder="请填写用户真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="权限" prop="permissionId">
                <el-select v-model="addUserForm.permissionId" placeholder="请选择用户权限" class="form-select">
                    <el-option v-for="permissionItem in permissionList" :key="permissionItem.permissionsId" :label="permissionItem.permissionsName" :value="permissionItem.permissionsId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="addUser('addUserForm')">立即创建</el-button>
                <el-button @click="clearUserData">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "usersAdd",
    data(){
        return {
            permissionList: null,
            addUserForm: {
                accountEmail: null,
                password: null,
                confirmPassword: null,
                userName: null,
                permissionId: null
            },
            validateRules: {
                accountEmail: [
                    { required: true, message: '请填写一点资讯邮箱', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请填写密码', trigger: 'blur' },
                    { min: 6,  message: '至少6个字符', trigger: 'blur' }
                ],
                confirmPassword: [
                    { required: true, message: '请再次填写密码', trigger: 'blur' },
                    { min: 6,  message: '至少6个字符', trigger: 'blur' }
                ],
                userName: [
                    { required: true, message: '请填写姓名', trigger: 'blur' },
                    { min: 2,  message: '至少2个字符', trigger: 'blur' }
                ],
                permissionId: [
                    // { required: true, message: '请选择用户权限', trigger: 'change' },
                    { required: true, type: 'number', message: '请选择用户权限'}
                ]
            }
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        addUser(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            if (this.addUserForm.accountEmail.indexOf('@yidian-inc.com') === -1) {
                this.$notify.error({
                    message: '非法邮箱'
                });
                return;
            }
            if (this.addUserForm.password !== this.addUserForm.confirmPassword) {
                this.$notify.error({
                    message: '两次输入密码不一致'
                });
                return;
            }
            let addUserData = {
                userName: this.addUserForm.userName,
                password: this.addUserForm.password,
                passwordAgain: this.addUserForm.confirmPassword,
                accountEmail: this.addUserForm.accountEmail,
                permissionsId: this.addUserForm.permissionId
            };
            this.$http.post(CONFIG.HOST + '/users/add', addUserData).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】用户创建成功'
                    });
                    this.clearUserData();
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        _getPermissions() {
            this.$http.get(CONFIG.HOST + '/users/listPermissions' + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.permissionList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        clearUserData(){
            this.addUserForm.accountEmail = null;
            this.addUserForm.password = null;
            this.addUserForm.confirmPassword = null;
            this.addUserForm.userName = null;
            this.addUserForm.permissionId = null;
        },
        _init(){
            this._getPermissions();
        }
    }
};
</script>
<style lang="less">
    .usersAdd{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .form-select{
            width: 100%;
        }
    }  
</style>


// WEBPACK FOOTER //
// Add.vue?5ba3fc31